import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssignmentData } from '../model/assignmentdata';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';

@Injectable({
    providedIn: 'root'
})
export class AssignmentService {

    constructor(private api: APIService){}

    getAssignments(): Observable<ReturnObject<AssignmentData[]>> {
        return this.api.getAPI('assignments');
    }

    setAssignmentEndDate(payload: object): Observable<ReturnObject<string>> {
        return this.api.putAPI(`assignments/setenddate`, payload);
    }

    removeAssignmentEndDate(payload: object): Observable<ReturnObject<string>> {
        return this.api.putAPI(`assignments/removeenddate`, payload);
    }

    setAssignmentExtendDate( payload: object): Observable<ReturnObject<string>> {
        return this.api.putAPI(`assignments/extenddate`, payload);
    }
    
    removeAssignmentExtendDate(payload: object): Observable<ReturnObject<string>> {
        return this.api.putAPI(`assignments/removeextenddate`, payload);
    }
}
